import { useState, useEffect } from "react"
import { useHistory, useLocation } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { info, placeholderLogo } from "../../../images"
import BottomBar from "../../BottomBar/bottombar"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { Input } from "@fourkites/elemental-input"
import AlertIcon from "components/AlertIcon/alertIcon"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import "./GateLinkCarrierSearch.css"
import { useTranslation } from "react-i18next"

const DispatchDetails = () => {
  const location = useLocation()
  const nextScreen = location.state
  const eventTracking = "/event-tracking"

  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()
  const [USDOT, setUSDOT] = useState("")
  const [carrier, setCarrier] = useState("")
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [name, setName] = useState("")
  const [isValidemail, setIsValidEmail] = useState(true)
  const [isValidphone, setIsValidPhone] = useState(true)
  const [isValidname, setIsValidName] = useState(true)
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const facilityReducer = useSelector(
    (state: RootState) => state.facilityReducer
  )
  const carrierSearchReducer = useSelector(
    (state: RootState) => state.carrierSearchReducer
  )

  useEffect(() => {
    setUSDOT(assetReducer.asset.usdot)
    setCarrier(assetReducer.asset.companyName)
  }, [])

  const getIdentification = (USDOT: string) => {
    let carrierArr = []
    let typeArr = ["usdot", "mc", "scac"]

    let carrier_Obj: any = {}
    carrier_Obj["type"] = "usdot"

    carrier_Obj["value"] = USDOT

    carrierArr.push(carrier_Obj)

    let obj: any = {}
    obj["identifications"] = carrierArr
    return obj
  }

  const setDispatchDetails = () => {
    let isValidemailFlag = true
    let isValidphoneFlag = true
    let isValidNameFlag = true

    if (email.trim() !== "") {
      let regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      isValidemailFlag = regexEmail.test(email)
      setIsValidEmail(isValidemailFlag)
    }

    if (phone.trim() !== "") {
      if (phone.length === 10 || phone.length === 0) {
        isValidphoneFlag = true
        setIsValidPhone(true)
      } else {
        isValidphoneFlag = false
        setIsValidPhone(false)
      }
    }

    if (isValidemailFlag && isValidphoneFlag && isValidNameFlag) {
      let facilityId = facilityReducer.facility.id
      let assetsId = assetReducer.asset.id

      let identificationObj = getIdentification(USDOT)

      let carrierContact: any = {}
      carrierContact["name"] = name
      carrierContact["phone"] = phone
      carrierContact["email"] = email

      let carrierObj: any = {}
      carrierObj["name"] = carrier
      carrierObj["identifications"] = identificationObj
        ? identificationObj.identifications
        : []
      carrierObj["contact"] = carrierContact
      http
        .post(
          `${apiEndPoints.inviteCarrier}`,
          {
            facilityId: facilityId,
            assetId: assetsId,
            carrier: carrierObj
          },
          {}
        )
        .then(response => {
          const { data } = response.data
          getNextScreen()
        })
        .catch(() => {
          getNextScreen()
        })
    }
  }

  function getNextScreen() {
    if (nextScreen === eventTracking) {
      history.push(eventTracking)
    } else {
      history.push("/tractor-info")
    }
  }

  useEffect(() => {
    if (email.trim() == "" && phone.trim() == "" && name.trim() == "") {
      setdisabledProceed(true)
    } else {
      setdisabledProceed(false)
    }
  }, [email, phone, name])

  const onInputClick = (e: any) => {
    if (e.target.name === "email") {
      setIsValidEmail(true)
    }
    if (e.target.name === "phone") {
      setIsValidPhone(true)
    }
    if (e.target.name === "name") {
      setIsValidName(true)
    }
  }

  const onInputChange = (e: any) => {
    if (e.target.name === "email") {
      setEmail(e.target.value)
    }
    if (e.target.name === "phone") {
      let numberRegex = /^[0-9]*$/
      let isOnlyNumber = numberRegex.test(e.target.value)
      if (isOnlyNumber) {
        setPhone(e.target.value)
      }
    }
    if (e.target.name === "name") {
      setName(e.target.value)
    }
  }

  const trans = (key: string) => {
    return t(key) || ""
  }

  return (
    <>
      <div className="container">
        <div className="carrier-search">
          <div className="carrier-search-noheight">
            <div className="carrier-title">
              {trans("add_dispatcher_details")}
            </div>
          </div>
        </div>
        <div className="dispatch-detail">
          <div className="dispatch-detail-info">
            <img src={info} />
            <p className="des_notify">
              {trans("not_in_fourkites_network_text")}
            </p>
          </div>
        </div>

        <div className={`carrier-search carrier-search-USDOT-font`}>
          <div className="container_in">
            <div className="logo_container">
              <img className="carrier-search-logo" src={placeholderLogo} />
              <div className="carrier-search-content">
                <div id={"carrier-search-company-name"}>
                  <h5 className="carrier-search-title">{carrier}</h5>
                </div>
                <div id={"carrier-search-company-ids"}>USDOT#: {USDOT}</div>
              </div>
              {/* <div className="carr_details">
                  <div className="carrier_desc">
                    <b>{carrier}</b>
                  </div>
                  <div>USDOT #:{USDOT}</div>
                </div> */}
            </div>

            <Input
              className={`${isValidemail ? "error-label" : ""}`}
              name="email"
              placeholder="example@example.com"
              label={trans("enter_dispatcher_email")}
              onChange={onInputChange}
              onClick={onInputClick}
              value={email}
              type="email"
              invalid={!isValidemail}
              errorLabel={
                !isValidemail ? trans("please_enter_valid_email") : ""
              }
              icon={
                !isValidemail ? (
                  <AlertIcon className="elemental-Input-icon--invalid" />
                ) : (
                  <></>
                )
              }
            />
            <Input
              className={`${isValidemail ? "error-label" : ""}`}
              name="phone"
              label={trans("enter_dispatcher_phone")}
              type="tel"
              placeholder={trans("enter_dispatcher_phone_here")}
              value={phone}
              onClick={onInputClick}
              onChange={onInputChange}
              size="large"
              maxLength={10}
              invalid={!isValidphone}
              errorLabel={
                !isValidphone ? trans("input_should_contain_10_digit") : ""
              }
              icon={
                !isValidphone ? (
                  <AlertIcon className="elemental-Input-icon--invalid" />
                ) : (
                  <></>
                )
              }
            />
            <Input
              className={`${isValidname ? "error-label" : ""}`}
              name="name"
              label={trans("enter_dispatcher_name")}
              type="text"
              placeholder={trans("enter_dispatcher_name_here")}
              value={name}
              onClick={onInputClick}
              onChange={onInputChange}
              size="large"
              invalid={!isValidname}
              errorLabel={!isValidname ? trans("name_is_required") : ""}
              icon={
                !isValidname ? (
                  <AlertIcon className="elemental-Input-icon--invalid" />
                ) : (
                  <></>
                )
              }
            />
          </div>
          <a
            href={`${
              nextScreen === eventTracking ? eventTracking : "/tractor-info"
            }`}
          >
            {t("skip")}
          </a>
        </div>
      </div>
      <BottomBar
        disabled={disabledProceed}
        onClick={() => setDispatchDetails()}
        text={t("save_and_proceed")}
        endIcon={<KeyboardArrowRightIcon />}
      />
    </>
  )
}

export default DispatchDetails
